// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-1[data-v-90d77f74]{position:absolute;bottom:0;left:0%;width:31.25rem;height:31.25rem;background:radial-gradient(circle closest-side, rgba(44, 148, 252, 0.15) 0%, rgba(44, 148, 252, 0) 100%);-webkit-transform:translate(-50%, 20%);transform:translate(-50%, 20%);pointer-events:none}.bg-1.reversed[data-v-90d77f74]{left:auto;right:0%;-webkit-transform:translate(50%, 20%);transform:translate(50%, 20%)}", ""]);
// Exports
module.exports = exports;
